import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "p-grid p-jc-center p-ai-center p-flex-column",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "p-p-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "300",
    height: "184",
    viewBox: "0 0 300 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip0)" }, [
      /*#__PURE__*/_createVNode("path", {
        opacity: "0.1007",
        d: "M266.186 56.8662C253.869 44.9845 239.021 -26.6469 188.15 10.6666C161.862 29.9428 117.531 -5.87925 80.8564 6.48276C47.1635 17.8462 43.9183 55.2862 47.1761 67.4839C53.7668 92.132 33.2679 95.7977 14.2601 106.377C-15.561 122.987 6.36627 181.346 34.5334 181.624C62.7006 181.902 233.357 181.068 233.357 181.068C233.357 181.068 274.28 181.182 291.296 155.661C309.602 128.194 297.999 87.5437 266.186 56.8662Z",
        fill: "#4360A8"
      }),
      /*#__PURE__*/_createVNode("g", null, [
        /*#__PURE__*/_createVNode("rect", {
          x: "64",
          y: "27",
          width: "182",
          height: "140",
          rx: "12.5607",
          fill: "#02A1D1"
        })
      ]),
      /*#__PURE__*/_createVNode("path", {
        d: "M160.746 141.987C159.229 149.225 163.792 156.334 170.936 157.865C178.081 159.397 185.102 154.771 186.618 147.534C188.135 140.296 183.573 133.187 176.428 131.656C169.284 130.124 162.262 134.75 160.746 141.987Z",
        fill: "#F3F9FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M171.36 155.845C177.393 157.138 183.34 153.231 184.621 147.119C185.904 140.994 182.048 134.985 176.002 133.689C169.968 132.396 164.034 136.306 162.751 142.43C162.221 144.959 162.564 147.469 163.582 149.63L173.68 144.773L167.606 154.289C168.734 155.01 169.989 155.551 171.36 155.845Z",
        fill: "#F7C137"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M218.814 158.136C226.129 158.136 232.058 152.148 232.058 144.761C232.058 137.374 226.129 131.385 218.814 131.385C211.5 131.385 205.57 137.374 205.57 144.761C205.57 152.148 211.5 158.136 218.814 158.136Z",
        fill: "#F3F9FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M218.814 133.448C212.625 133.448 207.613 138.51 207.613 144.761C207.613 147.848 208.841 150.645 210.833 152.695L218.814 144.761L229.277 148.797C229.753 147.544 230.003 146.19 230.003 144.761C230.003 138.51 224.992 133.448 218.814 133.448Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M217.173 139.016H212.412C212.224 139.016 212.073 139.167 212.073 139.357C212.073 139.547 212.224 139.699 212.412 139.699H217.173C217.361 139.699 217.511 139.547 217.511 139.357C217.511 139.167 217.361 139.016 217.173 139.016Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M217.173 140.104H212.412C212.224 140.104 212.073 140.256 212.073 140.445C212.073 140.635 212.224 140.787 212.412 140.787H217.173C217.361 140.787 217.511 140.635 217.511 140.445C217.511 140.256 217.361 140.104 217.173 140.104Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M214.379 141.192H212.412C212.224 141.192 212.073 141.344 212.073 141.534C212.073 141.723 212.224 141.875 212.412 141.875H214.379C214.567 141.875 214.717 141.723 214.717 141.534C214.717 141.344 214.567 141.192 214.379 141.192Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M229.509 40.3804H161.872C160.215 40.3804 158.872 41.7235 158.872 43.3804V120.276C158.872 121.933 160.215 123.276 161.872 123.276H229.509C231.166 123.276 232.509 121.933 232.509 120.276V43.3804C232.509 41.7235 231.166 40.3804 229.509 40.3804Z",
        fill: "#F3F9FF"
      }),
      /*#__PURE__*/_createVNode("g", { "clip-path": "url(#clip1)" }, [
        /*#__PURE__*/_createVNode("path", {
          d: "M175.218 99.1455H165V115H175.218V99.1455Z",
          fill: "#2196F3"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M191.244 92.4839H181.027V115.012H191.244V92.4839Z",
          fill: "#2196F3"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M207.271 81.9343H197.053V115.012H207.271V81.9343Z",
          fill: "#2196F3"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M223.298 72.8259H213.08V115.012H223.298V72.8259Z",
          fill: "#F7C137"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M226.756 51.1697C226.598 51.0364 226.379 50.9759 226.172 51.0001L219.486 52.066C219.096 52.1265 218.828 52.502 218.901 52.8896C218.962 53.2772 219.34 53.5436 219.73 53.471L224.089 52.7806L211.034 67.8479L205.7 62.7609C205.554 62.6277 205.371 62.555 205.164 62.5671C204.969 62.5792 204.787 62.664 204.653 62.8093L187.201 82.9759L182.135 79.209C181.855 79.0031 181.465 79.0274 181.209 79.2696L165.511 94.2158C165.231 94.4944 165.231 94.9426 165.524 95.2211C165.792 95.4876 166.23 95.4997 166.51 95.2454L181.757 80.6988L186.872 84.5141C187.177 84.7442 187.603 84.6958 187.847 84.4051L205.249 64.287L210.584 69.3741C210.73 69.5073 210.912 69.58 211.119 69.5679C211.314 69.5557 211.497 69.471 211.631 69.3256L225.539 53.2651L225.453 58.8971C225.441 59.2847 225.758 59.6118 226.16 59.6239H226.172C226.562 59.6239 226.878 59.309 226.89 58.9214L227 51.7268C227 51.5209 226.915 51.315 226.756 51.1697Z",
          fill: "#F7C137"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M205.956 57.2378H166.644C166.254 57.2378 165.926 56.9229 165.926 56.5232C165.926 56.1235 166.242 55.8086 166.644 55.8086H205.956C206.346 55.8086 206.674 56.1235 206.674 56.5232C206.674 56.9229 206.346 57.2378 205.956 57.2378Z",
          fill: "#2196F3"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M189.844 60.605H166.644C166.254 60.605 165.926 60.2901 165.926 59.8904C165.926 59.4907 166.242 59.1758 166.644 59.1758H189.844C190.234 59.1758 190.562 59.4907 190.562 59.8904C190.562 60.2901 190.234 60.605 189.844 60.605Z",
          fill: "#2196F3"
        })
      ]),
      /*#__PURE__*/_createVNode("path", {
        d: "M78 116.226C76.3431 116.226 75 117.569 75 119.226V153.997C75 155.653 76.3431 156.997 78 156.997H142.129C143.786 156.997 145.129 155.653 145.129 153.997V119.226C145.129 117.569 143.786 116.226 142.129 116.226H78Z",
        fill: "#AED3FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M77.2805 116.226V156.997H147.41V116.226H77.2805Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M96.4634 148.164C103.466 148.164 109.144 142.431 109.144 135.358C109.144 128.286 103.466 122.553 96.4634 122.553C89.4604 122.553 83.7833 128.286 83.7833 135.358C83.7833 142.431 89.4604 148.164 96.4634 148.164Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M118.516 131.006H139.516C140.28 131.006 140.894 130.373 140.894 129.614C140.894 128.842 140.267 128.222 139.516 128.222H118.516C117.751 128.222 117.138 128.854 117.138 129.614C117.138 130.373 117.764 131.006 118.516 131.006Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M139.528 133.967H118.516C117.751 133.967 117.138 134.599 117.138 135.358C117.138 136.118 117.764 136.75 118.516 136.75H139.516C140.28 136.75 140.894 136.118 140.894 135.358C140.894 134.599 140.293 133.967 139.528 133.967Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M139.528 139.724H118.516C117.751 139.724 117.138 140.357 117.138 141.116C117.138 141.888 117.764 142.508 118.516 142.508H139.516C140.28 142.508 140.894 141.875 140.894 141.116C140.906 140.344 140.292 139.724 139.528 139.724Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M96.4635 135.573L84.861 135.422C84.861 135.472 84.861 135.523 84.861 135.573C84.861 142.052 90.0608 147.304 96.476 147.304C98.769 147.304 100.899 146.633 102.703 145.469L96.4635 135.573Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M96.8896 139.256H90.5871C90.2237 139.256 89.9355 139.547 89.9355 139.914C89.9355 140.281 90.2237 140.572 90.5871 140.572H96.8896C97.2529 140.572 97.5411 140.281 97.5411 139.914C97.5411 139.56 97.2529 139.256 96.8896 139.256Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M92.028 141.66H90.5871C90.2237 141.66 89.9355 141.951 89.9355 142.318C89.9355 142.685 90.2237 142.976 90.5871 142.976H92.028C92.3914 142.976 92.6796 142.685 92.6796 142.318C92.6796 141.951 92.3789 141.66 92.028 141.66Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M144.422 58.3342H78.6392C76.9823 58.3342 75.6392 59.6774 75.6392 61.3342V104.305C75.6392 105.962 76.9823 107.305 78.6392 107.305H144.422C146.079 107.305 147.422 105.962 147.422 104.305V61.3342C147.422 59.6774 146.079 58.3342 144.422 58.3342Z",
        fill: "#F3F9FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M78.5962 83.3256C78.5962 83.3256 90.8503 81.7818 98.3431 88.7541C105.836 95.7264 119.781 89.3742 125.395 88.7541C135.155 87.6785 142.811 90.9053 145.092 94.4484V105.09H78.5962V83.3256Z",
        fill: "#F7C137"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M88.6075 66.2048H88.0938V82.8194H88.6075V66.2048Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M108.755 73.3291H108.242V89.9436H108.755V73.3291Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M129.555 69.5708H129.041V86.1853H129.555V69.5708Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M94.346 68.7484H90.4117C90.1737 68.7484 89.9857 68.5586 89.9857 68.3182C89.9857 68.0778 90.1737 67.8879 90.4117 67.8879H94.346C94.5841 67.8879 94.772 68.0778 94.772 68.3182C94.772 68.5586 94.5716 68.7484 94.346 68.7484Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M94.346 70.3048H90.4117C90.1737 70.3048 89.9857 70.115 89.9857 69.8746C89.9857 69.6341 90.1737 69.4443 90.4117 69.4443H94.346C94.5841 69.4443 94.772 69.6341 94.772 69.8746C94.772 70.115 94.5716 70.3048 94.346 70.3048Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M114.193 77.2264H110.259C110.021 77.2264 109.833 77.0366 109.833 76.7962C109.833 76.5558 110.021 76.366 110.259 76.366H114.193C114.431 76.366 114.619 76.5558 114.619 76.7962C114.619 77.024 114.431 77.2264 114.193 77.2264Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M114.193 78.745H110.259C110.021 78.745 109.833 78.5552 109.833 78.3148C109.833 78.0743 110.021 77.8845 110.259 77.8845H114.193C114.431 77.8845 114.619 78.0743 114.619 78.3148C114.619 78.5552 114.431 78.745 114.193 78.745Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M135.331 70.9628H131.397C131.159 70.9628 130.971 70.773 130.971 70.5325C130.971 70.2921 131.159 70.1023 131.397 70.1023H135.331C135.569 70.1023 135.757 70.2921 135.757 70.5325C135.757 70.7603 135.569 70.9628 135.331 70.9628Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M135.331 72.4813H131.397C131.159 72.4813 130.971 72.2915 130.971 72.0511C130.971 71.8107 131.159 71.6208 131.397 71.6208H135.331C135.569 71.6208 135.757 71.8107 135.757 72.0511C135.757 72.2915 135.569 72.4813 135.331 72.4813Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M277.165 184H26.0317C25.117 184 24.3903 183.254 24.3903 182.342C24.3903 181.419 25.1295 180.685 26.0317 180.685H277.165C278.08 180.685 278.807 181.431 278.807 182.342C278.807 183.254 278.08 184 277.165 184Z",
        fill: "#4360A8"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M40.6089 168.043L42.2503 175.028L44.7061 175.016L44.8063 168.043H40.6089Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M61.2831 168.347L65.9567 175.028L67.7735 172.662L64.9668 167.423L61.2831 168.347Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M49.1542 76.3156C48.3022 75.8221 47.2873 75.7715 46.5731 75.8221C46.761 75.6323 47.1119 75.5563 47.1119 75.5563C46.6733 75.4931 45.6835 75.936 45.6835 75.936C39.5439 73.5444 38.5791 82.6678 38.7169 84.7937C38.8422 86.9195 36.6495 87.6028 33.467 89.2731C27.3775 92.4619 26.8387 96.7263 26.8387 96.7263C26.8889 96.7516 26.939 96.7895 26.9891 96.8275C27.2898 96.3087 27.9163 95.3343 28.4426 95.1951C28.4175 95.2458 27.8286 96.5365 27.6031 97.2704C29.3948 98.6497 32.7653 101.712 35.1084 103.876C35.0958 103.458 35.1084 102.851 35.2713 102.534L35.5594 104.293C36.8124 105.457 37.677 106.28 37.677 106.28C37.5266 104.572 45.3452 95.5241 49.4299 92.8162C50.4197 91.3357 50.7831 88.729 50.8082 88.5266C50.6327 90.6018 50.2819 91.7533 49.9687 92.4113C53.4143 89.1846 51.397 77.6063 49.1542 76.3156Z",
        fill: "#2E3B61"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M49.1793 92.9427C49.2044 92.9553 47.2121 93.993 45.7086 93.588C44.3052 93.1958 43.378 91.3483 43.4031 91.3483C44.0045 91.2344 44.1674 90.3992 44.1549 86.8435L44.4305 86.8941L48.9663 87.8052C48.9663 87.8052 48.8661 89.2477 48.8661 90.6017C48.841 91.7406 48.9162 92.8161 49.1793 92.9427Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M49.0916 77.6822C49.0916 77.6822 47.4502 77.3911 44.0421 77.8087L49.0916 77.6822Z",
        fill: "#E37970"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M48.9537 87.8054C48.9537 87.8054 48.8535 89.2479 48.8535 90.6019C46.31 90.526 44.9693 88.185 44.418 86.8943L48.9537 87.8054Z",
        fill: "#D79560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M43.9544 86.388C43.9544 86.388 42.6263 84.2621 42.3005 82.4526C42.075 81.1619 42.7265 76.3535 47.5004 77.0494C47.5004 77.0494 48.8912 77.1886 50.1943 78.0744C51.2342 78.783 52.7253 80.3141 51.0588 84.5025L50.6203 85.9198L43.9544 86.388Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M67.0343 170.84L64.6286 170.916L62.0224 170.992C62.0224 170.992 56.0081 164.235 52.6376 153.39C52.5624 153.137 52.4747 152.884 52.387 152.631C50.5451 147.19 46.711 140.37 44.6937 134.194C44.3679 133.207 44.0797 132.284 43.8291 131.411C43.7414 131.132 43.6663 130.854 43.5911 130.588C42.1 125.375 41.674 121.946 41.2731 118.289L55.8327 118.402C55.8452 118.402 58.2008 143.381 67.0343 170.84Z",
        fill: "#1C468A"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M53.8384 110.194C53.8025 117.166 54.8081 120.154 54.8081 120.154C54.8081 120.154 48.846 123.344 41.7705 120.999C41.6867 120.974 35.9042 119.587 35.9042 119.587C36.0239 119.309 37.0774 114.607 37.1972 114.342C38.6937 110.963 39.831 109.475 39.9986 108.441C40.3219 106.5 40.3339 104.495 40.1662 102.604C39.7352 97.5855 38.4542 93.4248 38.4542 93.4248C40.3817 92.9583 42.2374 92.1766 44.2487 91.3822C44.7156 91.9874 46.0685 92.6052 47.3016 92.5674C48.7143 92.5296 49.1573 91.9118 49.0974 91.1931C50.6059 92.0757 51.7912 92.9078 51.7912 92.9078C53.0722 95.2404 55.6581 97.5098 55.8497 101.103C55.9096 101.998 53.8504 110.005 53.8384 110.194Z",
        fill: "#2196F3"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M41.2855 110.734C40.6465 111.645 39.4311 117.175 36.3989 117.871C37.9651 113.936 39.1555 112.202 39.3309 110.987C39.6692 108.722 39.6817 106.381 39.5063 104.18C40.5212 102.383 41.2855 101.143 41.2855 101.143C41.3607 100.852 42.9019 96.0558 43.3905 100.345C43.8792 104.635 41.9997 109.722 41.2855 110.734Z",
        fill: "#F2564B"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M49.8058 89.0835C49.8058 89.0835 43.8041 89.1847 43.7915 85.4012C43.7915 81.6177 43.0147 79.0869 46.8488 78.8718C50.6829 78.644 51.4347 80.0866 51.7354 81.352C52.0361 82.6174 51.372 88.9569 49.8058 89.0835Z",
        fill: "#EBAF7F"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M51.56 79.2514C50.6328 78.1126 49.9311 78.3657 49.5427 78.7073C48.2396 76.746 44.1424 79.5804 44.1424 79.5804C43.7414 82.2884 41.7993 83.8448 41.7993 83.8448C41.7993 83.8448 42.8894 84.5281 45.4204 83.8701C47.4127 83.3513 48.8536 80.5042 49.3673 79.302C49.7307 79.6184 50.4824 80.365 50.708 81.0862C51.0087 82.0479 51.1465 84.0346 51.7104 83.9587C51.7104 83.9713 52.9508 80.9597 51.56 79.2514Z",
        fill: "#2E3B61"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M42.1752 174.636C42.1752 174.636 42.3757 176.015 41.8619 177.496C41.8619 177.496 41.461 179.343 43.2653 179.381C45.0696 179.419 45.5081 179.242 45.3077 178.103C45.1072 176.964 44.7187 175.003 44.7187 175.003L42.1752 174.636Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M45.4705 180.293H41.7241C41.5237 179.318 41.8494 177.496 41.8494 177.496C43.8918 179.47 45.1698 177.446 45.1698 177.446C45.5081 178.293 45.4705 180.293 45.4705 180.293Z",
        fill: "#F7C137"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M72.1339 178.382C72.1339 178.382 68.801 174.56 67.7861 172.662L65.3052 173.94L70.8433 179.192L72.1339 179.014V178.382Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M74.1761 180.292H69.5526C69.1516 179.925 68.7632 179.179 68.2871 178.204C68.0114 177.648 67.41 177.331 66.7835 177.167V180.305H65.8313L64.9416 176.977C64.3528 175.863 64.7913 174.838 65.2048 173.953C65.6809 173.953 67.0842 174.307 69.5401 177.154C70.3545 178.09 71.2441 178.419 72.1212 178.394C72.1337 178.407 72.1462 178.407 72.1588 178.419C73.5621 179.052 74.0257 179.849 74.1761 180.292Z",
        fill: "#F7C137"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M73.9506 95.3597C73.9506 95.3597 70.0037 97.5868 68.6004 98.2321C68.0992 98.4599 67.1971 98.8901 66.2698 99.3203C65.706 99.5861 65.1422 99.8518 64.6535 100.092C63.8265 100.484 62.8367 100.269 62.2478 99.5734C60.1177 97.0553 54.5921 91.6015 48.8785 90.9182L48.8535 90.9055C48.8535 90.9055 48.8535 90.9055 48.8535 90.9182C48.8535 90.9182 48.8535 90.9182 48.8409 90.9182L48.8785 90.9814C49.2043 91.7913 52.3242 99.6747 52.4245 101.345C52.5247 103.104 52.8379 130.044 52.8379 130.044C52.8379 130.044 52.6375 131.284 54.9805 130.765C57.3361 130.246 57.9501 129.728 57.9501 129.728C57.9501 129.728 55.7073 113.113 56.3087 107.33C56.434 106.191 56.3212 104.926 56.0706 103.61C59.5414 105.736 63.6386 106.685 63.6386 106.685C63.6386 106.685 65.1672 106.014 67.5354 104.521C68.5377 103.901 69.6905 102.901 70.8307 101.851C72.209 100.573 74.5771 97.4982 74.5771 97.4982L73.9506 95.3597Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M64.6285 170.903L62.0223 170.979C62.0223 170.979 56.008 164.222 52.6375 153.378C52.5624 153.125 52.4747 152.872 52.3869 152.618C50.5451 147.177 46.711 140.357 44.6937 134.182C44.3679 133.195 44.0797 132.271 43.8291 131.398C43.7414 131.12 43.6662 130.841 43.5911 130.575L45.7337 128.93C45.7337 128.93 52.1739 139.458 54.1662 149.366C55.9078 157.984 62.8368 168.335 64.6285 170.903Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M45.9717 150.29C46.0093 155.111 45.7712 166.184 45.1447 170.777H42.8393C41.5612 170.777 40.9348 170.764 40.9348 170.764C39.3811 162.792 38.2659 156.2 37.464 150.505C36.7999 145.836 36.211 141.838 35.76 138.396C35.3089 134.929 34.9831 132.031 34.8703 129.576C34.8578 129.184 34.8453 128.817 34.8328 128.45C34.8202 128.083 34.8202 127.728 34.8328 127.387L47.4126 126.147C47.2372 134.587 45.9467 147.494 45.9717 150.29Z",
        fill: "#1C468A"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M42.8393 170.777C41.5612 170.777 40.9348 170.764 40.9348 170.764C39.3811 162.792 38.2659 156.199 37.464 150.505C36.7999 145.836 36.211 141.837 35.76 138.395C35.3089 134.928 34.9831 132.031 34.8704 129.576L39.4813 132.322C39.4813 132.322 36.5368 133.372 37.6645 141.318C38.7796 149.265 41.2731 169.65 42.8393 170.777Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M43.4282 129.5C43.4282 129.5 42.5385 132.739 39.4813 132.322C36.4115 131.904 32.0511 130.057 32.0511 130.057C32.0511 130.057 33.3668 125.881 34.9956 120.376C36.9628 113.72 39.4061 105.154 40.5588 99.7504C40.8846 98.232 41.0976 96.9666 41.1853 96.0682L43.779 91.0825C43.779 91.0825 47.5129 99.6872 47.7259 101.851C47.9263 104.002 43.4282 129.5 43.4282 129.5Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M54.3792 104.255C52.9007 104.445 52.3368 105.242 52.1614 106.305C52.0612 106.887 51.773 107.457 51.5224 107.849C50.0564 107.925 46.5481 108.115 43.6161 108.305L43.3781 112.202C45.7963 111.898 48.7658 111.278 52.1739 110.101C52.4371 110.051 52.7628 109.886 53.1763 109.557C55.2938 107.811 56.4967 104.875 56.4967 104.458C56.4842 104.04 55.8577 104.065 54.3792 104.255Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M43.2904 106.381C43.1526 109.886 42.3381 116.707 35.0458 120.351C35.0207 120.364 35.0082 120.376 34.9832 120.376C36.9503 113.72 39.3936 105.154 40.5464 99.7505C41.8996 101.762 43.3656 104.445 43.2904 106.381Z",
        fill: "#EBF3FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M43.779 91.0701C43.779 91.0701 37.5392 91.513 36.0481 94.8915C34.5446 98.2575 34.0684 109.481 35.9855 112.784C35.9855 112.784 38.6167 113.543 43.2527 112.658C43.3154 112.645 43.3655 112.632 43.4282 112.62C43.4282 112.62 44.9067 108.95 43.5785 108.229C43.5785 108.229 39.6567 108.431 40.0702 107.128C40.4711 105.824 43.779 91.0701 43.779 91.0701Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M78.1732 92.7151C74.8152 92.2849 73.9757 95.3598 73.9757 95.3598L74.6022 97.473C75.6422 97.6121 76.5443 97.3464 77.3713 96.1443C78.2108 94.9422 78.4363 95.3977 78.9626 94.4993C79.6893 93.2845 78.5616 92.829 78.1732 92.7151Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M68.6004 98.2196C68.0992 98.4474 67.1971 98.8776 66.2699 99.3078C66.7711 100.194 67.385 101.813 67.5479 104.483C68.5503 103.863 69.8409 102.813 70.931 101.725C72.6977 99.9785 74.5771 97.4604 74.5771 97.4604L73.9506 95.3472C73.9506 95.3598 70.0038 97.5869 68.6004 98.2196Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M261.797 87.9316C261.797 87.9316 269.979 96.4603 270.367 99.6744C270.756 102.889 266.47 107.925 266.47 107.925L261.797 87.9316Z",
        fill: "#EBF3FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M258.301 176.408C258.301 176.408 258.025 180.938 257.148 181.001C257.035 181.014 252.738 181.014 252.738 181.014L247.262 180.976C247.262 180.976 247.3 179.647 248.904 179.356C250.507 179.078 253.189 177.939 254.154 175.8C255.181 173.561 258.301 176.408 258.301 176.408Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M270.505 176.408C270.505 176.408 270.229 180.938 269.352 181.001C269.24 181.014 264.942 181.014 264.942 181.014L259.454 180.988C259.454 180.988 259.504 179.647 261.108 179.356C262.712 179.078 265.393 177.939 266.358 175.8C267.385 173.561 270.505 176.408 270.505 176.408Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M252.237 127.791C252.237 127.791 253.665 137.041 259.015 153.466C264.353 169.891 265.092 177.002 265.092 177.002C265.092 177.002 266.533 177.217 268.062 177.217C269.027 177.217 270.818 176.838 270.818 176.838C270.818 176.838 270.868 158.894 268.4 150.631C265.932 142.369 267.874 120.857 267.874 120.857L252.237 127.791Z",
        fill: "#163560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M249.455 121.363C249.455 121.363 249.255 135.308 251.635 152.416C254.028 169.536 253.214 176.8 253.214 176.8C253.214 176.8 255.181 177.154 255.87 177.179C256.609 177.205 258.927 176.989 258.927 176.989C258.927 176.989 262.348 159.869 261.371 151.302C260.393 142.735 266.057 121.907 266.057 121.907L249.455 121.363Z",
        fill: "#1C468A"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M260.519 88.7415L257.825 90.7535L253.928 89.9183C253.978 89.564 254.241 88.0708 254.479 86.7169C254.492 86.641 254.504 86.5524 254.517 86.4765C254.717 85.325 254.893 84.338 254.893 84.338L258.539 82.5031L259.892 81.8198C259.892 81.8451 259.792 83.0979 259.767 83.275C259.516 86.5397 260.519 88.7415 260.519 88.7415Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M254.204 87.7165C254.292 87.6786 259.504 86.1221 260.08 86.3119C260.644 86.5017 260.982 87.6026 260.982 87.6026L252.45 89.5514C252.437 89.564 253.114 88.1847 254.204 87.7165Z",
        fill: "#EBF3FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M268.25 123.084C267.36 127.159 252.638 127.639 248.854 123.945C248.428 123.527 248.402 121.566 248.565 118.921C248.879 113.758 249.906 105.976 249.944 102.003C249.969 100.079 250.219 98.118 250.57 96.3464C251.309 92.5503 252.437 89.5766 252.437 89.5766C252.437 89.5766 259.629 87.223 260.97 87.6279C267.46 89.5386 269.139 119.01 268.25 123.084Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M248.565 118.908C248.879 113.746 249.906 105.963 249.944 101.99C249.969 100.067 250.219 98.1054 250.57 96.3339L254.893 95.562C254.893 95.562 259.128 113.012 248.565 118.908Z",
        fill: "#EBF3FF"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M250.909 111.708C250.909 111.708 251.209 112.417 250.583 112.898C249.969 113.379 249.568 114.15 249.706 114.72C249.844 115.289 251.209 116.213 251.673 116.061C252.149 115.909 253.101 115.163 253.001 114.872C252.901 114.568 253.64 112.252 252.5 111.354C251.347 110.456 250.909 111.708 250.909 111.708Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M255.745 88.5137C255.745 88.5137 251.522 89.3109 248.164 94.3092C244.806 99.3074 242.589 103.028 243.215 104.837C243.829 106.634 249.48 112.898 250.457 112.898C251.435 112.898 253.001 112.189 253.089 110.569C253.089 110.569 249.117 104.559 249.894 103.648C250.232 103.268 255.056 99.3074 255.745 101.092C256.873 104.065 255.745 88.5137 255.745 88.5137Z",
        fill: "white"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M259.491 83.3635C258.689 84.9073 255.707 86.2486 254.467 86.7421C254.479 86.6662 254.492 86.5776 254.504 86.5017C254.705 85.3502 254.88 84.3632 254.88 84.3632L258.527 82.5284C259.341 82.5157 259.83 82.7182 259.491 83.3635Z",
        fill: "#D79560"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M252.823 84.4596C252.823 84.4596 259.401 86.6292 260.624 82.2738C261.833 77.9184 263.5 75.263 259.355 73.6925C255.209 72.1219 253.924 73.5306 253.175 74.8744C252.441 76.2183 251.14 83.7796 252.823 84.4596Z",
        fill: "#FFB27D"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M253.619 74.7265C253.619 74.7265 254.032 79.6344 255.025 79.4306C256.018 79.211 256.919 79.0543 256.767 80.5439C256.629 82.0178 255.254 83.727 258.295 83.9935C261.35 84.2601 265.735 76.1847 264.895 74.6481C262.481 70.2262 250.12 69.3325 253.619 74.7265Z",
        fill: "#163560"
      })
    ]),
    /*#__PURE__*/_createVNode("defs", null, [
      /*#__PURE__*/_createVNode("filter", {
        id: "filter0_d",
        x: "53.2336",
        y: "21.6168",
        width: "203.533",
        height: "161.533",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
      }, [
        /*#__PURE__*/_createVNode("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }),
        /*#__PURE__*/_createVNode("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }),
        /*#__PURE__*/_createVNode("feOffset", { dy: "5.38318" }),
        /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "5.38318" }),
        /*#__PURE__*/_createVNode("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.247059 0 0 0 0 0.54902 0 0 0 0 1 0 0 0 0.263686 0"
        }),
        /*#__PURE__*/_createVNode("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }),
        /*#__PURE__*/_createVNode("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })
      ]),
      /*#__PURE__*/_createVNode("clipPath", { id: "clip0" }, [
        /*#__PURE__*/_createVNode("rect", {
          width: "300",
          height: "184",
          fill: "white"
        })
      ]),
      /*#__PURE__*/_createVNode("clipPath", { id: "clip1" }, [
        /*#__PURE__*/_createVNode("rect", {
          width: "62",
          height: "64",
          fill: "white",
          transform: "translate(165 51)"
        })
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "p-text-secondary" }
const _hoisted_4 = { class: "p-p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("h5", null, _toDisplayString(_ctx.$t(_ctx.expType.toLowerCase() + ".label.empty.title")), 1),
    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.expType.toLowerCase() + ".label.empty.description")), 1),
    _createVNode("div", _hoisted_4, [
      (_ctx.canEdit())
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-plus",
            label: _ctx.$t('button.create.experiment'),
            onClick: _ctx.toggle,
            "aria-haspopup": "true",
            "aria-controls": "overlay_menu"
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Menu, {
        id: "overlay_menu",
        ref: "menu",
        model: _ctx.items,
        popup: true
      }, null, 8, ["model"])
    ])
  ]))
}